import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
const urlApiDev = process.env.API_BASE_URL_DEV
const urlApiProd = process.env.API_BASE_URL
const keyDev = process.env.DEV_SAFE2PAY_KEY
const keyProd = process.env.PROD_SAFE2PAY_KEY

const isDev = [
  'localhost',
  'homologacao.senhadigitalplus.com.br',
  'homologacao.certificadorapadrao.com.br',
  'link.senhadigitalplus.com.br',
].includes(window.location.hostname)

const urlApi = isDev ? urlApiDev : urlApiProd
const key = isDev ? keyDev : keyProd
const headers = {
  'x-api-key': `${key}`,
  'content-type': 'application/json',
}

export const state = () => ({
  paymentSafe2Pay: null,
  statusPayment: {},
})

export const getters = {
  allStatusPayment: (state) => {
    const metodoPagamento = {
      1: 'Boleto',
      2: 'Cartão de Crédito',
      6: 'Pix',
    }

    const formattedDataHoraCriacao =
      state.statusPayment.dataHoraCriacao &&
      format(
        new Date(state.statusPayment.dataHoraCriacao),
        "EEEE, d 'de' MMMM 'de' yyyy",
        { locale: ptBR }
      )

    return {
      ...state.statusPayment,
      metodoPagamento: metodoPagamento[state.statusPayment.metodoPagamento],
      dataHoraformatted: formattedDataHoraCriacao,
    }
  },
}

export const mutations = {
  SET_STATUS_PAYMENT: (state, payload) => (state.statusPayment = payload),
}

export const actions = {
  async createTokenCreditCardSafe2Pay({ commit }, token) {
    const data = await this.$axios.$post(
      `${urlApiProd}/safe2pay/v1/token`,
      token,
      {
        headers: {
          'x-api-key': keyProd,
          'content-type': 'application/json',
        },
      }
    )
    return data
  },
  async paymentCreditCardSafe2Pay({ commit }, paymentData) {
    const data = await this.$axios.$post(
      `${urlApi}/safe2pay/v1/cartao-credito`,
      paymentData,
      { headers }
    )
    return data
  },
  async boletoPayment({ commit }, paymentData) {
    const data = await this.$axios.$post(
      `${urlApi}/safe2pay/v1/boleto`,
      paymentData,
      {
        headers,
      }
    )
    return data
  },
  async pixPayment({ commit }, paymentData) {
    const data = await this.$axios.$post(
      `${urlApiProd}/safe2pay/v1/pix`,
      paymentData,
      {
        headers: {
          'x-api-key': keyProd,
          'content-type': 'application/json',
        },
      }
    )
    return data
  },
  async statusPayment({ commit }, { idTransacao, vendedor }) {
    const data = await this.$axios.$get(
      `${urlApi}/safe2pay/v1/status/${idTransacao}`,
      {
        headers,
        params: {
          vendedor,
        },
      }
    )
    commit('SET_STATUS_PAYMENT', data)
  },
}
